import { Injectable } from '@angular/core';

@Injectable( )
export class ForgetPasswordStepService {
    email!: string;
    code!:string;
    constructor() { }
    
}